/* eslint-disable max-len */
import {
  audienceNetworkInStreamVideos,
  audienceNetworkNativeBanner,
  audienceNetworkRewardedVideos,
  facebookInstantArticle,
  facebookInStreamVideos,
  facebookMarketPlace,
  facebookNewsFeed,
  facebookRightColumn,
  facebookSearchResults,
  facebookStories,
  facebookVideoFeeds,
  instagramExplore,
  instagramFeed,
  instagramIGTV,
  instagramReels,
  instagramShop,
  instagramStories,
  messengerInbox,
  messengerSponsoredMessages,
  messengerStories,
} from '../assets';
import color from './color';

export const CAMPAIGN_OBJECTIVE = {
  REACH: 'REACH',
  VIDEO_VIEWS: 'VIDEO_VIEWS',
  CATALOGUE_SALES: 'catalogue-sales',
  STORE_VISITS: 'store-visits',
  PRE_ROLL_VIEWS: 'PREROLL_VIEWS',
  APP_INSTALLS: 'APP_INSTALLS',
  WEBSITE_CLICKS: 'WEBSITE_CLICKS',
  ENGAGEMENT: 'TWEET_ENGAGEMENTS',
  FOLLOWERS: 'FOLLOWERS',
  APP_RE_ENGAGEMENT: 'APP_ENGAGEMENTS',
};

export const INTEGRATOR_TWITTER = () => {
  const STATUS = {
    DRAFT: 1,
    APPROVAL: 2,
    PUBLISHED: 3,
    REJECTED: 4,
  };

  const STATUS_LIST = [
    {
      value: STATUS.DRAFT,
      label: 'Draft',
      backgroundColor: color.grey2,
      color: color.black1,
    },
    {
      value: STATUS.APPROVAL,
      label: 'Approval',
      backgroundColor: color.purple6,
      color: color.purple1,
    },
    {
      value: STATUS.PUBLISHED,
      label: 'Published',
      backgroundColor: color.green6,
      color: color.green1,
    },
    {
      value: STATUS.REJECTED,
      label: 'Rejected',
      backgroundColor: color.red6,
      color: color.red1,
    },
  ];

  const CAMPAIGN_OBJECTIVE_TYPE = {
    REACH: 'REACH',
    VIDEO_VIEWS: 'VIDEO_VIEWS',
    ENGAGEMENT: 'TWEET_ENGAGEMENTS',
    FOLLOWERS: 'FOLLOWERS',
  };

  const CAMPAIGN_OBJECTIVE_OPTION = [
    // {
    //   key: 'awareness',
    //   title: 'Awareness',
    //   options: [
    //     {
    //       value: CAMPAIGN_OBJECTIVE.REACH,
    //       label: 'Reach',
    //     },
    //   ],
    // },
    {
      key: 'consideration',
      title: 'Consideration',
      options: [
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.VIDEO_VIEWS,
          label: 'Video views',
        },
        // {
        //   value: CAMPAIGN_OBJECTIVE.PRE_ROLL_VIEWS,
        //   label: 'Pre-roll views',
        // },
        // {
        //   value: CAMPAIGN_OBJECTIVE.APP_INSTALLS,
        //   label: 'App Installs',
        // },
        // {
        //   value: CAMPAIGN_OBJECTIVE.WEBSITE_CLICKS,
        //   label: 'Website clicks',
        // },
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.ENGAGEMENT,
          label: 'Engagement',
        },
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.FOLLOWERS,
          label: 'Followers',
        },
      ],
    },
    // {
    //   key: 'conversion',
    //   title: 'Conversion',
    //   options: [
    //     {
    //       value: CAMPAIGN_OBJECTIVE.APP_RE_ENGAGEMENT,
    //       label: 'App re-engagement',
    //     },
    //   ],
    // },
  ];

  const PRODUCT_TYPE = {
    MEDIA: 'MEDIA',
    PROMOTED_ACCOUNT: 'PROMOTED_ACCOUNT',
    PROMOTED_TWEETS: 'PROMOTED_TWEETS',
  };

  // video views
  // selected tweet is organic: promoted_tweet
  // selected tweet is scheduled: promoted_tweet
  // selected tweet is promoted: promoted_tweet

  // engagement
  // selected tweet is organic: promoted_tweet
  // selected tweet is scheduled: promoted_tweet
  // selected tweet is promoted: promoted_tweet

  // followers
  // selected tweet is organic: promoted_account
  // selected tweet is scheduled: promoted_account
  // selected tweet is promoted: promoted_account

  const PRODUCT_TYPE_OBJECTIVE = [
    {
      objective: CAMPAIGN_OBJECTIVE.VIDEO_VIEWS,
      type: PRODUCT_TYPE.PROMOTED_TWEETS,
    },
    {
      objective: CAMPAIGN_OBJECTIVE.ENGAGEMENT,
      type: PRODUCT_TYPE.PROMOTED_TWEETS,
    },
    {
      objective: CAMPAIGN_OBJECTIVE.FOLLOWERS,
      type: PRODUCT_TYPE.PROMOTED_ACCOUNT,
    },
  ];

  const BID_STRATEGY_TYPE = {
    AUTO: 'AUTO',
    MAX: 'MAX',
    TARGET: 'TARGET',
  };

  const BID_STRATEGY_OPTION = [
    {
      value: BID_STRATEGY_TYPE.AUTO,
      label: 'Autobid (Recommended)',
      description: 'Automatically maximize your results at the lowest price.',
    },
    {
      value: BID_STRATEGY_TYPE.MAX,
      label: 'Maximum Bid',
      description:
        'Set a maximum you’ll never bid over. Bidding higher helps your ad display more often.',
    },
    {
      value: BID_STRATEGY_TYPE.TARGET,
      label: 'Target Cost',
      description:
        'Set a target cost to maintain an average cost per 1K impressions.',
    },
  ];

  const BID_OPTION = [
    {
      value: 1,
      label: 'Autobid (Recommended)',
      description: 'Automatically maximize your results at the lowest price.',
    },
  ];

  const BID_MULTI_OPTION = [
    {
      value: 1,
      label: 'Autobid (Recommended)',
      description: 'Automatically maximize your results at the lowest price.',
    },
    {
      value: 2,
      label: 'Maximum Bid',
      description:
        'Set a maximum you’ll never bid over. Bidding higher helps your ad display more often.',
    },
  ];

  const AUDIENCE_PLACEMENT_TYPE = {
    ALL_ON_TWITTER: 'ALL_ON_TWITTER',
    PUBLISHER_NETWORK: 'PUBLISHER_NETWORK',
    TAP_BANNER: 'TAP_BANNER',
    TAP_FULL: 'TAP_FULL',
    TAP_FULL_LANDSCAPE: 'TAP_FULL_LANDSCAPE',
    TAP_NATIVE: 'TAP_NATIVE',
    TAP_MRECT: 'TAP_MRECT',
    TWITTER_PROFILE: 'TWITTER_PROFILE',
    TWITTER_SEARCH: 'TWITTER_SEARCH',
    TWITTER_TIMELINE: 'TWITTER_TIMELINE',
  };

  const AUDIENCE_PLACEMENT_OPTION = [
    {
      value: AUDIENCE_PLACEMENT_TYPE.TWITTER_TIMELINE,
      label: 'Home timelines',
    },
    {
      value: AUDIENCE_PLACEMENT_TYPE.TWITTER_PROFILE,
      label: 'Profiles',
    },
    {
      value: AUDIENCE_PLACEMENT_TYPE.TWITTER_SEARCH,
      label: 'Search results',
    },
  ];

  const KEYWORDS_OPTION = [
    {
      value: 'include',
      label: 'Include',
    },
    {
      value: 'exclude',
      label: 'Exclude',
    },
  ];

  const RE_TARGETING_TYPE_OPTION = [
    {
      value: 'saw_tweets',
      label: 'People who saw your Tweets',
    },
  ];

  const TIMELINE_TYPE = {
    ORGANIC: 'ORGANIC',
    NULLCAST: 'NULLCAST',
    ALL: 'ALL',
  };

  const TIMELINE_TYPE_OPTION = [
    {
      value: TIMELINE_TYPE.ORGANIC,
      label: 'Organic Tweets',
    },
    {
      value: TIMELINE_TYPE.NULLCAST,
      label: 'Promoted-only Tweets',
    },
  ];

  const TWEET_TYPE = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    SCHEDULED: 'SCHEDULED',
  };

  const TWEET_TYPE_OPTION = [
    {
      value: TWEET_TYPE.DRAFT,
      label: 'Draft',
    },
    {
      value: TWEET_TYPE.PUBLISHED,
      label: 'Published',
    },
    {
      value: TWEET_TYPE.SCHEDULED,
      label: 'Scheduled',
    },
  ];

  const TWEET_FILTER_OPTION = [
    {
      timeline_type: TIMELINE_TYPE.ORGANIC,
      tweet_type: TWEET_TYPE.PUBLISHED,
      label: 'Organic Tweets',
    },
    {
      timeline_type: TIMELINE_TYPE.ALL,
      tweet_type: TWEET_TYPE.SCHEDULED,
      label: 'Scheduled Tweets',
    },
    {
      timeline_type: TIMELINE_TYPE.NULLCAST,
      tweet_type: TWEET_TYPE.PUBLISHED,
      label: 'Promoted-only Tweets',
    },
  ];

  const EXPAND_AUDIENCE_OPTION = {
    0: 'DEFINIED',
    1: 'EXPANDED',
    2: 'BROAD',
  };

  const GENDER_TYPE = {
    ANY: 'any',
    MEN: 'MALE',
    WOMAN: 'FEMALE',
  };

  const GENDER_OPTION = [
    {
      value: 'any',
      label: 'Any',
    },
    {
      value: GENDER_TYPE.MEN,
      label: 'Men',
    },
    {
      value: GENDER_TYPE.WOMAN,
      label: 'Woman',
    },
  ];

  const AGE_OPTION = [
    {
      value: 'all',
      label: 'All',
    },
    {
      value: 'range',
      label: 'Age Range',
    },
  ];

  const FREQUENCY_CAP_OPTION = [
    {
      value: true,
      label: 'Automatically optimize ad frequency (recommended) ',
    },
    // {
    //   value: false,
    //   label: 'Set a custom cap ',
    // },
  ];

  const PACING_OPTION = [
    {
      value: true,
      label: 'Standard (recommended)',
      description:
        'Show ads throughout the day to spend budget as efficiently as possible.',
    },
    {
      value: false,
      label: 'Accelerated',
      description:
        'For time-constrained campaigns, like major sporting events, show ads as often as possible each day.',
    },
  ];

  const TARGET_PEOPLE_OPTION = [
    {
      value: 'last',
      label: 'Within the last',
    },
  ];

  const GOAL_TYPE = {
    APP_CLICKS: 'APP_CLICKS',
    APP_INSTALLS: 'APP_INSTALLS',
    ENGAGEMENT: 'ENGAGEMENT',
    FOLLOWERS: 'FOLLOWERS',
    LINK_CLICKS: 'LINK_CLICKS',
    MAX_REACH: 'MAX_REACH',
    PREROLL: 'PREROLL',
    PREROLL_STARTS: 'PREROLL_STARTS',
    REACH_WITH_ENGAGEMENT: 'REACH_WITH_ENGAGEMENT',
    VIDEO_VIEW: 'VIDEO_VIEW',
    VIEW_3S_100PCT: 'VIEW_3S_100PCT',
    VIEW_6S: 'VIEW_6S',
    VIEW_15S: 'VIEW_15S',
    WEBSITE_CONVERSIONS: 'WEBSITE_CONVERSIONS',
  };

  const GOAL_OPTION = {
    REACH: [
      {
        value: GOAL_TYPE.MAX_REACH,
        label: 'Max Reach (Recommended)',
        extra: 'Get your ad to reach more people.',
        help: 'average cost per 1K impressions',
      },
      {
        value: GOAL_TYPE.REACH_WITH_ENGAGEMENT,
        label: 'Reach with engagement',
        extra:
          'Get your ad to reach the people who are likely to Retweet, like and reply to it.',
        help: 'average cost per 1K impressions',
      },
    ],
    VIDEO_VIEW: [
      {
        value: GOAL_TYPE.VIEW_15S,
        label: '15s video views (recommended)',
        extra: 'Get people to watch your video for up to 15 seconds.',
        help: '',
      },
      {
        value: GOAL_TYPE.VIEW_6S,
        label: '6s video views',
        extra:
          // eslint-disable-next-line max-len
          'Get people to watch your video in 50% view for at least 6 seconds. Note: Your creatives will be filtered for 15 seconds or less.',
        help: 'maximum bid per 6s video view',
      },
      {
        value: GOAL_TYPE.VIEW_3S_100PCT,
        label: '3s/100% video views',
        extra:
          'Get people to watch your video in 100% view for at least 3 seconds.',
        help: 'maximum bid per 3s/100% video view',
      },
      {
        value: GOAL_TYPE.VIDEO_VIEW,
        label: 'Video views',
        extra:
          'Get people to watch your video in 50% view for at least 2 seconds.',
        help: 'maximum bid per video view',
      },
    ],
    ENGAGEMENT: [
      {
        value: GOAL_TYPE.ENGAGEMENT,
        label: 'Engagement',
        extra: 'Get people to Retweet, like, and reply to your ad.',
        help: 'maximum bid per engagement',
      },
    ],
    FOLLOWERS: [
      {
        value: GOAL_TYPE.FOLLOWERS,
        label: 'Followers',
        extra: 'Get more new followers.',
        help: 'average cost per follower',
      },
    ],
  };

  const TARGETING_TYPE = {
    AGE: 'AGE',
    DEVICE: 'DEVICE',
    EVENT: 'EVENT',
    CAMPAIGN_ENGAGEMENT: 'CAMPAIGN_ENGAGEMENT',
    CAMPAIGN_ENGAGEMENT_LOOKALIKE: 'CAMPAIGN_ENGAGEMENT_LOOKALIKE',
    CONVERSATION: 'CONVERSATION',
    ENGAGEMENT_TYPE: 'ENGAGEMENT_TYPE',
    FOLLOWERS_OF_USER: 'FOLLOWERS_OF_USER',
    GENDER: 'GENDER',
    INTEREST: 'INTEREST',
    LANGUAGE: 'LANGUAGE',
    LIVE_TV_EVENT: 'LIVE_TV_EVENT',
    LOCATION: 'LOCATION',
    NETWORK_ACTIVATION_DURATION: 'NETWORK_ACTIVATION_DURATION',
    NETWORK_OPERATOR: 'NETWORK_OPERATOR',
    PLATFORM: 'PLATFORM',
    PLATFORM_VERSION: 'PLATFORM_VERSION',
    SIMILAR_TO_FOLLOWERS_OF_USER: 'SIMILAR_TO_FOLLOWERS_OF_USER',
    TV_SHOW: 'TV_SHOW',
    USER_ENGAGEMENT: 'USER_ENGAGEMENT',
    USER_ENGAGEMENT_LOOKALIKE: 'USER_ENGAGEMENT_LOOKALIKE',
    WIFI_ONLY: 'WIFI_ONLY',
  };

  const CONVERSION_SETTING_TYPE = {
    EVERYONE: 'EVERYONE',
    FOLLOWING: 'FOLLOWING',
    MENTIONED_USERS: 'MENTIONED_USERS',
  };

  const CONVERSION_SETTING_OPTION = [
    {
      value: CONVERSION_SETTING_TYPE.EVERYONE,
      label: 'Everyone can replay',
    },
    {
      value: CONVERSION_SETTING_TYPE.FOLLOWING,
      label: 'People you follow',
    },
    {
      value: CONVERSION_SETTING_TYPE.MENTIONED_USERS,
      label: 'Only people you mention',
    },
  ];

  const INPUT_MEDIA_TYPE = {
    SINGLE: 'SINGLE',
    CAROUSEL: 'CAROUSEL',
  };

  const INPUT_MEDIA_OPTION = [
    {
      value: INPUT_MEDIA_TYPE.SINGLE,
      label: 'Single Image or Video',
      desc: 'One image or video, or a slideshow with multiple images',
    },
    {
      value: INPUT_MEDIA_TYPE.CAROUSEL,
      label: 'Carousel',
      desc: '2 or more scrollable images or videos',
    },
  ];

  const CARD_TYPE = {
    WEBSITE: 'website',
    APP: 'app',
    NO_CARD: 'no_card',
  };

  const CARD_TYPE_OPTION = [
    {
      value: CARD_TYPE.WEBSITE,
      label: 'Website',
      desc: 'Include a call to action to your website.',
    },
    {
      value: CARD_TYPE.APP,
      label: 'App',
      desc: 'Include a call to action to your app.',
    },
    {
      value: CARD_TYPE.NO_CARD,
      label: 'No Card',
      desc: 'Choose this option to display 2-4 photos in a grid with no call to action.',
    },
  ];

  const CTA_TYPE = {
    BOOK: 'BOOK',
    CONNECT: 'CONNECT',
    INSTALL: 'INSTALL',
    OPEN: 'OPEN',
    ORDER: 'ORDER',
    PLAY: 'PLAY',
    SHOP: 'SHOP',
  };

  const CTA_TYPE_OPTION = [
    {
      value: CTA_TYPE.BOOK,
      label: 'Book',
    },
    {
      value: CTA_TYPE.CONNECT,
      label: 'Connect',
    },
    {
      value: CTA_TYPE.INSTALL,
      label: 'Install',
    },
    {
      value: CTA_TYPE.OPEN,
      label: 'Open',
    },
    {
      value: CTA_TYPE.ORDER,
      label: 'Order',
    },
    {
      value: CTA_TYPE.PLAY,
      label: 'Play',
    },
    {
      value: CTA_TYPE.SHOP,
      label: 'Shop',
    },
  ];

  const PUBLICATION_STATUS = {
    DRAFT: 'DRAFT',
    SCHEDULE: 'SCHEDULE',
    TWEET: 'TWEET',
  };

  const PUBLICATION_STATUS_OPTION = [
    {
      value: PUBLICATION_STATUS.DRAFT,
      label: 'Save draft',
    },
    {
      value: PUBLICATION_STATUS.SCHEDULE,
      label: 'Schedule',
    },
    {
      value: PUBLICATION_STATUS.TWEET,
      label: 'Tweet',
    },
  ];

  const MEDIA_CATEGORY = {
    AMPLIFY_VIDEO: 'AMPLIFY_VIDEO',
    TWEET_GIF: 'TWEET_GIF',
    TWEET_IMAGE: 'TWEET_IMAGE',
    TWEET_VIDEO: 'TWEET_VIDEO',
  };

  const MEDIA_CATEGORY_OPTION = [
    {
      key: 'image/jpeg',
      category: MEDIA_CATEGORY.TWEET_IMAGE,
    },
    {
      key: 'video/mp4',
      category: MEDIA_CATEGORY.TWEET_VIDEO,
    },
    {
      key: 'image/gif',
      category: MEDIA_CATEGORY.TWEET_GIF,
    },
    {
      key: 'image/png',
      category: MEDIA_CATEGORY.TWEET_IMAGE,
    },
  ];

  return {
    CAMPAIGN_OBJECTIVE_TYPE,
    STATUS,
    STATUS_LIST,
    CAMPAIGN_OBJECTIVE_OPTION,
    BID_OPTION,
    BID_MULTI_OPTION,
    AUDIENCE_PLACEMENT_TYPE,
    AUDIENCE_PLACEMENT_OPTION,
    KEYWORDS_OPTION,
    RE_TARGETING_TYPE_OPTION,
    TIMELINE_TYPE,
    TIMELINE_TYPE_OPTION,
    TWEET_TYPE,
    TWEET_TYPE_OPTION,
    EXPAND_AUDIENCE_OPTION,
    GENDER_TYPE,
    GENDER_OPTION,
    AGE_OPTION,
    FREQUENCY_CAP_OPTION,
    PACING_OPTION,
    TARGET_PEOPLE_OPTION,
    BID_STRATEGY_TYPE,
    BID_STRATEGY_OPTION,
    GOAL_TYPE,
    GOAL_OPTION,
    TARGETING_TYPE,
    CONVERSION_SETTING_TYPE,
    CONVERSION_SETTING_OPTION,
    INPUT_MEDIA_TYPE,
    INPUT_MEDIA_OPTION,
    CARD_TYPE,
    CARD_TYPE_OPTION,
    CTA_TYPE,
    CTA_TYPE_OPTION,
    PUBLICATION_STATUS,
    PUBLICATION_STATUS_OPTION,
    PRODUCT_TYPE,
    PRODUCT_TYPE_OBJECTIVE,
    MEDIA_CATEGORY,
    MEDIA_CATEGORY_OPTION,
    TWEET_FILTER_OPTION,
  };
};

export const INTEGRATOR_FACEBOOK = () => {
  const CAMPAIGN_OBJECTIVE_TYPE = {
    BRAND_AWARENESS: 'BRAND_AWARENESS',
    REACH: 'REACH',
    TRAFFIC: 'LINK_CLICKS',
    POST_ENGAGEMENT: 'POST_ENGAGEMENT',
    PAGE_LIKES: 'PAGE_LIKES',
    EVENT_RESPONSES: 'EVENT_RESPONSES',
    MESSAGES: 'MESSAGES',
    CONVERSIONS: 'CONVERSIONS',
    STORE_VISITS: 'STORE_VISITS',
    // VIDEO_VIEWS: 'VIDEO_VIEWS',
    // LEAD_GENERATION: 'lead-generation',
    // CATALOGUE_SALES: 'catalogue-sales',
    // STORE_VISITS: 'store-visits',
    // PRE_ROLL_VIEWS: 'PREROLL_VIEWS',
    // APP_INSTALLS: 'APP_INSTALLS',
    // WEBSITE_CLICKS: 'WEBSITE_CLICKS',
    // FOLLOWERS: 'FOLLOWERS',
    // APP_RE_ENGAGEMENT: 'APP_ENGAGEMENTS',
  };

  const CONNECTION_TYPE = {
    PAGE: {
      CONNECTIONS: 'connections',
      FRIENDS_OF_CONNECTIONS: 'friends_of_connections',
      EXCLUDED_CONNECTIONS: 'excluded_connections',
    },
  };

  const CONNECTION_LIST = [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Facebook Pages',
      value: 'FACEBOOK_PAGES',
      children: [
        {
          label: 'People who currently like or follow your Page',
          value: CONNECTION_TYPE.PAGE.CONNECTIONS,
          type: 'FACEBOOK_PAGES',
        },
        {
          label:
            'People similar to those who currently like or follow your page',
          value: CONNECTION_TYPE.PAGE.FRIENDS_OF_CONNECTIONS,
          type: 'FACEBOOK_PAGES',
        },
        {
          label: 'Exclude people who currently like or follow your Page',
          value: CONNECTION_TYPE.PAGE.EXCLUDED_CONNECTIONS,
          type: 'FACEBOOK_PAGES',
        },
      ],
    },
    {
      label: 'Apps',
      value: 'APPS',
      children: [
        {
          label: 'People who used your app',
          value: 'connectedToApp',
          type: 'APPS',
        },
        {
          label: 'People similar to those who used your app',
          value: 'friendsConnectedToApp',
          type: 'APPS',
        },
        {
          label: 'Exclude people who used your app',
          value: 'excludeConnectedToApp',
          type: 'APPS',
        },
      ],
    },
    {
      label: 'Events',
      value: 'EVENTS',
      children: [
        {
          label: 'People who responded to your event',
          value: 'connectedToEvent',
          type: 'EVENTS',
        },
        {
          label: 'Exclude people who already responded to your event',
          value: 'excludeConnectedToEvent',
          type: 'EVENTS',
        },
      ],
    },
  ];

  const CAMPAIGN_OBJECTIVE_OPTION = [
    {
      key: 'awareness',
      title: 'Awareness',
      options: [
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.BRAND_AWARENESS,
          label: 'Brand Awareness',
        },
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.REACH,
          label: 'Reach',
        },
      ],
    },
    {
      key: 'consideration',
      title: 'Consideration',
      options: [
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
          label: 'Traffic',
        },
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
          label: 'Engagement',
          subOptions: [
            {
              value: CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
              label: 'Post engagement',
            },
            {
              value: CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
              label: 'Page likes',
            },
            {
              value: CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
              label: 'Event responses',
            },
          ],
        },
        // {
        //   value: 'APP_INSTALLS',
        //   label: 'App Installs',
        // },
        // {
        //   value: 'VIDEO_VIEWS',
        //   label: 'Video views',
        // },

        // {
        //   value: 'LEAD_GENERATION',
        //   label: 'Lead Generation',
        // },
        // {
        //   value: CAMPAIGN_OBJECTIVE_TYPE.MESSAGES,
        //   label: 'Messages',
        // },
      ],
    },
    {
      key: 'conversion',
      title: 'Conversion',
      options: [
        {
          value: CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
          label: 'Conversions',
        },
        // {
        //   value: 'PRODUCT_CATALOG_SALES',
        //   label: 'Catalogue Sales',
        // },
        // {
        //   value: CAMPAIGN_OBJECTIVE_TYPE.STORE_VISITS,
        //   label: 'Store Visits',
        // },
      ],
    },
  ];

  const BUYING_TYPE_OPTION = [
    {
      value: 'AUCTION',
      label: 'Auction',
    },
  ];

  const AD_CATEGORIES_TYPE = {
    CREDIT: 'CREDIT',
    EMPLOYMENT: 'EMPLOYMENT',
    HOUSING: 'HOUSING',
    ISSUES_ELECTIONS_POLITICS: 'ISSUES_ELECTIONS_POLITICS',
    NONE: 'NONE',
  };

  const AD_CATEGORIES_LIST = [
    {
      id: AD_CATEGORIES_TYPE.CREDIT,
      name: 'Credit',
      desc: 'Ads for credit card offers, auto loans, long-term financing or other related opportunities.',
    },
    {
      id: AD_CATEGORIES_TYPE.EMPLOYMENT,
      name: 'Employment',
      desc: 'Ads for job offers, internships, professional certification programs or other related opportunities.',
    },
    {
      id: AD_CATEGORIES_TYPE.HOUSING,
      name: 'Housing',
      desc: 'Ads for real estate listings, homeowners insurance, mortgage loans or other related opportunities.',
    },
    {
      id: AD_CATEGORIES_TYPE.ISSUES_ELECTIONS_POLITICS,
      name: 'Social Issues, Elections or Politics',
      // eslint-disable-next-line max-len
      desc: 'Ads about social issues (such as the economy, or civil and social rights), elections, or political figures or campaigns.',
    },
  ];

  const BUDGET_TYPE = {
    DAILY: 'daily_budget',
    LIFETIME: 'lifetime_budget',
  };

  const BUDGET_OPTION = [
    {
      value: BUDGET_TYPE.DAILY,
      label: 'Daily Budget',
    },
    {
      value: BUDGET_TYPE.LIFETIME,
      label: 'Lifetime Budget',
    },
  ];

  const BID_STRATEGY_TYPE = {
    LOWEST: 'LOWEST_COST_WITHOUT_CAP',
    BID: 'LOWEST_COST_WITH_BID_CAP',
    COST: 'COST_CAP',
  };

  const BID_STRATEGY_OPTION = [
    {
      value: BID_STRATEGY_TYPE.LOWEST,
      label: 'Highest Volume',
      description: 'Get the most results for your budget.',
      objectives: [
        CAMPAIGN_OBJECTIVE_TYPE.BRAND_AWARENESS,
        CAMPAIGN_OBJECTIVE_TYPE.REACH,
        CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
        CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
        CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
        CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
        CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      ],
    },
    {
      value: BID_STRATEGY_TYPE.BID,
      label: 'Bid cap',
      description: 'Set the highest you want to bid in any auction.',
      objectives: [
        CAMPAIGN_OBJECTIVE_TYPE.REACH,
        CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
        CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
        CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
        CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
        CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      ],
    },
    {
      value: BID_STRATEGY_TYPE.COST,
      label: 'Cost cap',
      description:
        'Control your costs while getting the most volume of results for your budget',
      name: 'Cost Control',
      objectives: [],
    },
  ];

  const BID_STRATEGY_TYPE_DETAIL = {
    LOWEST: {
      value: BID_STRATEGY_TYPE.LOWEST,
      label: 'Highest Volume',
      description: 'Get the most results for your budget',
      name: 'Cost Control (Optional)',
    },
    BID: {
      value: BID_STRATEGY_TYPE.BID,
      label: 'Bid cap',
      description: 'Control your bid in each auction',
      name: 'Bid Control',
    },
    COST: {
      value: BID_STRATEGY_TYPE.COST,
      label: 'Cost cap',
      description:
        'Control your costs while getting the most volume of results for your budget',
      name: 'Cost Control',
    },
  };

  const OPTIMIZATION_GOAL_TYPE = {
    NONE: 'NONE',
    APP_INSTALLS: 'APP_INSTALLS',
    BRAND_AWARENESS: 'BRAND_AWARENESS',
    AD_RECALL_LIFT: 'AD_RECALL_LIFT',
    CLICKS: 'CLICKS',
    ENGAGED_USERS: 'ENGAGED_USERS',
    EVENT_RESPONSES: 'EVENT_RESPONSES',
    IMPRESSIONS: 'IMPRESSIONS',
    LEAD_GENERATION: 'LEAD_GENERATION',
    QUALITY_LEAD: 'QUALITY_LEAD',
    LINK_CLICKS: 'LINK_CLICKS',
    OFFER_CLAIMS: 'OFFER_CLAIMS',
    OFFSITE_CONVERSIONS: 'OFFSITE_CONVERSIONS',
    PAGE_ENGAGEMENT: 'PAGE_ENGAGEMENT',
    PAGE_LIKES: 'PAGE_LIKES',
    POST_ENGAGEMENT: 'POST_ENGAGEMENT',
    QUALITY_CALL: 'QUALITY_CALL',
    REACH: 'REACH',
    SOCIAL_IMPRESSIONS: 'SOCIAL_IMPRESSIONS',
    APP_DOWNLOADS: 'APP_DOWNLOADS',
    TWO_SECOND_CONTINUOUS_VIDEO_VIEWS: 'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS',
    LANDING_PAGE_VIEWS: 'LANDING_PAGE_VIEWS',
    VISIT_INSTAGRAM_PROFILE: 'VISIT_INSTAGRAM_PROFILE',
    VALUE: 'VALUE',
    THRUPLAY: 'THRUPLAY',
    REPLIES: 'REPLIES',
    DERIVED_EVENTS: 'DERIVED_EVENTS',
    CONVERSATIONS: 'CONVERSATIONS',
  };

  const OPTIMIZATION_GOAL_DETAIL = {
    AD_RECALL_LIFT: {
      value: OPTIMIZATION_GOAL_TYPE.AD_RECALL_LIFT,
      label: 'Ad Recall Lift',
      desc: '',
      bid_control: BID_STRATEGY_TYPE.COST,
    },
    REACH: {
      value: OPTIMIZATION_GOAL_TYPE.REACH,
      label: 'Reach',
      desc: "We'll serve your ads to the maximum number of people.",
      bid_control: BID_STRATEGY_TYPE.BID,
    },
    IMPRESSIONS: {
      value: OPTIMIZATION_GOAL_TYPE.IMPRESSIONS,
      label: 'Impressions',
      desc: "We'll deliver your ads to people as many times as possible.",
      bid_control: BID_STRATEGY_TYPE.BID,
    },
    LANDING_PAGE_VIEWS: {
      value: OPTIMIZATION_GOAL_TYPE.LANDING_PAGE_VIEWS,
      label: 'Landing Page Views',
      desc: "We'll deliver your ads to people who are more likely to click on your ad's link and load the website or Instant Experience.",
      bid_control: BID_STRATEGY_TYPE.COST,
    },
    LINK_CLICKS: {
      value: OPTIMIZATION_GOAL_TYPE.LINK_CLICKS,
      label: 'Link Clicks',
      desc: "We'll deliver your ads to the people most likely to click on them.",
      bid_control: BID_STRATEGY_TYPE.COST,
    },
    DAILY_REACH: {
      value: OPTIMIZATION_GOAL_TYPE.REACH,
      label: 'Daily Unique Reach',
      desc: "We'll deliver your ads to people up to once a day.",
      bid_control: BID_STRATEGY_TYPE.BID,
    },
    POST_ENGAGEMENT: {
      value: OPTIMIZATION_GOAL_TYPE.POST_ENGAGEMENT,
      label: 'Post Engagement',
      desc: "We'll deliver your ads to the right people to help you get the most likes, shares, or comments on your post at the lowest cost.",
      bid_control: BID_STRATEGY_TYPE.COST,
    },
    PAGE_LIKES: {
      value: OPTIMIZATION_GOAL_TYPE.PAGE_LIKES,
      label: 'Page Likes',
      desc: '',
      bid_control: BID_STRATEGY_TYPE.COST,
    },
    EVENT_RESPONSES: {
      value: OPTIMIZATION_GOAL_TYPE.EVENT_RESPONSES,
      label: 'Event Response',
      desc: "We'll deliver your ads to the right people to help you get the most event interest at the lowest cost.",
      bid_control: BID_STRATEGY_TYPE.COST,
    },
    CONVERSATIONS: {
      value: OPTIMIZATION_GOAL_TYPE.CONVERSATIONS,
      label: 'Conversations',
      desc: "We'll deliver your ads to people most likely to have a conversation with you through messaging.",
      bid_control: BID_STRATEGY_TYPE.BID,
    },
    LEAD_GENERATION: {
      value: OPTIMIZATION_GOAL_TYPE.LEAD_GENERATION,
      label: 'Leads',
      desc: "We'll deliver your ads to help you get the most leads possible.",
      bid_control: BID_STRATEGY_TYPE.BID,
    },
    OFFSITE_CONVERSIONS: {
      value: OPTIMIZATION_GOAL_TYPE.OFFSITE_CONVERSIONS,
      label: 'Conversions',
      desc: "We'll deliver your ads to the right people to help you get the most website conversions.",
      bid_control: BID_STRATEGY_TYPE.COST,
    },
  };

  const BID_STRATEGY_OBJECTIVE = [
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.BRAND_AWARENESS,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.AD_RECALL_LIFT],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.REACH,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.REACH,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.REACH,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.LANDING_PAGE_VIEWS,
            OPTIMIZATION_GOAL_DETAIL.LINK_CLICKS,
            OPTIMIZATION_GOAL_DETAIL.DAILY_REACH,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.COST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.LANDING_PAGE_VIEWS,
            OPTIMIZATION_GOAL_DETAIL.LINK_CLICKS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.LANDING_PAGE_VIEWS,
            OPTIMIZATION_GOAL_DETAIL.LINK_CLICKS,
            OPTIMIZATION_GOAL_DETAIL.DAILY_REACH,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.POST_ENGAGEMENT,
            OPTIMIZATION_GOAL_DETAIL.DAILY_REACH,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.COST,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.POST_ENGAGEMENT],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.POST_ENGAGEMENT,
            OPTIMIZATION_GOAL_DETAIL.DAILY_REACH,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.PAGE_LIKES],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.COST,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.PAGE_LIKES],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.PAGE_LIKES],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.POST_ENGAGEMENT,
            OPTIMIZATION_GOAL_DETAIL.DAILY_REACH,
            OPTIMIZATION_GOAL_DETAIL.EVENT_RESPONSES,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.COST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.POST_ENGAGEMENT,
            OPTIMIZATION_GOAL_DETAIL.EVENT_RESPONSES,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.POST_ENGAGEMENT,
            OPTIMIZATION_GOAL_DETAIL.DAILY_REACH,
            OPTIMIZATION_GOAL_DETAIL.EVENT_RESPONSES,
            OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS,
          ],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.MESSAGES,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.LINK_CLICKS,
            OPTIMIZATION_GOAL_DETAIL.CONVERSATIONS,
            OPTIMIZATION_GOAL_DETAIL.LEAD_GENERATION,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.LINK_CLICKS,
            OPTIMIZATION_GOAL_DETAIL.CONVERSATIONS,
            OPTIMIZATION_GOAL_DETAIL.LEAD_GENERATION,
          ],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.OFFSITE_CONVERSIONS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.COST,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.OFFSITE_CONVERSIONS,
          ],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [
            OPTIMIZATION_GOAL_DETAIL.OFFSITE_CONVERSIONS,
          ],
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.STORE_VISITS,
      bid_strategy_option: [
        {
          ...BID_STRATEGY_TYPE_DETAIL.LOWEST,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS],
        },
        {
          ...BID_STRATEGY_TYPE_DETAIL.BID,
          optimization_goal_option: [OPTIMIZATION_GOAL_DETAIL.IMPRESSIONS],
        },
      ],
    },
  ];

  const AD_SCHEDULING_TYPE = {
    ALL_TIME: false,
    SCHEDULE: true,
  };

  const AD_SCHEDULING_OPTION = [
    {
      value: AD_SCHEDULING_TYPE.ALL_TIME,
      label: 'Run ads all the time',
    },
    {
      value: AD_SCHEDULING_TYPE.SCHEDULE,
      label: 'Run ads on a schedule',
    },
  ];

  const OPTIMIZATION_GOAL_OPTION = [
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.BRAND_AWARENESS,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.AD_RECALL_LIFT,
          label: 'Ad Recall Lift',
          desc: '',
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.REACH,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.REACH,
          label: 'Reach',
          desc: "We'll serve your ads to the maximum number of people.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.IMPRESSIONS,
          label: 'Impressions',
          desc: "We'll deliver your ads to people as many times as possible.",
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.LANDING_PAGE_VIEWS,
          label: 'Landing Page Views',
          desc: "We'll deliver your ads to people who are more likely to click on your ad's link and load the website or Instant Experience.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.LINK_CLICKS,
          label: 'Link Clicks',
          desc: "We'll deliver your ads to the people most likely to click on them.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.REACH,
          label: 'Daily Unique Reach',
          desc: "We'll deliver your ads to people up to once a day.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.IMPRESSIONS,
          label: 'Impressions',
          desc: "We'll deliver your ads to people as many times as possible.",
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.POST_ENGAGEMENT,
          label: 'Post Engagement',
          desc: "We'll deliver your ads to the right people to help you get the most likes, shares, or comments on your post at the lowest cost.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.REACH,
          label: 'Daily Unique Reach',
          desc: "We'll deliver your ads to people up to once a day.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.IMPRESSIONS,
          label: 'Impressions',
          desc: "We'll deliver your ads to people as many times as possible.",
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.PAGE_LIKES,
          label: 'Page Likes',
          desc: '',
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.POST_ENGAGEMENT,
          label: 'Post Engagement',
          desc: "We'll deliver your ads to the right people to help you get the most likes, shares, or comments on your post at the lowest cost.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.REACH,
          label: 'Daily Unique Reach',
          desc: "We'll deliver your ads to people up to once a day.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.EVENT_RESPONSES,
          label: 'Event Response',
          desc: "We'll deliver your ads to the right people to help you get the most event interest at the lowest cost.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.IMPRESSIONS,
          label: 'Impressions',
          desc: "We'll deliver your ads to people as many times as possible.",
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.MESSAGES,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.LINK_CLICKS,
          label: 'Link Clicks',
          desc: "We'll deliver your ads to the people most likely to click on them.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.CONVERSATIONS,
          label: 'Conversations',
          desc: "We'll deliver your ads to people most likely to have a conversation with you through messaging.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.LEAD_GENERATION,
          label: 'Leads',
          desc: "We'll deliver your ads to help you get the most leads possible.",
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      options: [
        {
          value: OPTIMIZATION_GOAL_TYPE.OFFSITE_CONVERSIONS,
          label: 'Conversions',
          desc: "We'll deliver your ads to the right people to help you get the most website conversions.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.LANDING_PAGE_VIEWS,
          label: 'Landing Page Views',
          desc: "We'll deliver your ads to people who are more likely to click on your ad's link and load the website or Instant Experience.",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.LINK_CLICKS,
          label: 'Link Clicks',
          desc: "We'll deliver your ads to the people most likely to click on them",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.REACH,
          label: 'Daily Unique Reach',
          desc: "We'll deliver your ads to people up to once a day",
        },
        {
          value: OPTIMIZATION_GOAL_TYPE.IMPRESSIONS,
          label: 'Impressions',
          desc: "We'll deliver your ads to people as many times as possible.",
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.STORE_VISITS,
      options: [],
    },
  ];

  const BILLING_EVENT_TYPE = {
    APP_INSTALLS: 'APP_INSTALLS',
    CLICKS: 'CLICKS',
    IMPRESSIONS: 'IMPRESSIONS',
    LINK_CLICKS: 'LINK_CLICKS',
    NONE: 'NONE',
    OFFER_CLAIMS: 'OFFER_CLAIMS',
    PAGE_LIKES: 'PAGE_LIKES',
    POST_ENGAGEMENT: 'POST_ENGAGEMENT',
    THRUPLAY: 'THRUPLAY',
    PURCHASE: 'PURCHASE',
    LISTING_INTERACTION: 'LISTING_INTERACTION',
  };

  const BILLING_EVENT_OPTION = [
    {
      value: BILLING_EVENT_TYPE.IMPRESSIONS,
      label: 'Impression',
    },
    // {
    //   value: BILLING_EVENT_TYPE.LINK_CLICKS,
    //   label: 'Link Click (CPC)',
    // },
    {
      value: BILLING_EVENT_TYPE.THRUPLAY,
      label: 'ThruPlay',
    },
    {
      value: BILLING_EVENT_TYPE.PAGE_LIKES,
      label: 'Page Like',
    },
  ];

  const ACTION_ATTRIBUTION_WINDOWS_OPTION = [
    {
      label: 'After clicking ad',
      children: [
        {
          value: '1d_click',
          label: '1-day click',
        },
        {
          value: '7d_click',
          label: '7-day click',
        },
      ],
    },
    {
      label: 'After clicking or viewing ad',
      children: [
        {
          value: '1d_view',
          label: '1-day click or view',
        },
        {
          value: '7d_view',
          label: '7-day click or 1-day view',
        },
      ],
    },
  ];

  const GENDER_TYPE = {
    ALL: 0,
    MEN: 1,
    WOMEN: 2,
  };

  const GENDER_OPTION = [
    {
      value: GENDER_TYPE.ALL,
      label: 'All',
    },
    {
      value: GENDER_TYPE.MEN,
      label: 'Men',
    },
    {
      value: GENDER_TYPE.WOMEN,
      label: 'Women',
    },
  ];

  const DESTINATION_TYPE = {
    WEBSITE: 'WEBSITE',
    APP: 'APP',
    WEBSITE_APP: 'WEBSITE_APP',
    MESSENGER: 'MESSENGER',
    WHATSAPP: 'WHATSAPP',
  };

  const DESTINATION_OPTION = [
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      options: [
        {
          value: DESTINATION_TYPE.WEBSITE,
          label: 'Website',
          desc: '',
        },
        {
          value: DESTINATION_TYPE.APP,
          label: 'App',
          desc: '',
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
      options: [
        {
          value: DESTINATION_TYPE.WEBSITE,
          label: 'Website',
          desc: '',
        },
        {
          value: DESTINATION_TYPE.APP,
          label: 'App',
          desc: "Choose the app you want to advertise. You can advertise any app that you've registered on Facebook's developer site.",
        },
      ],
    },
  ];

  const CUSTOM_EVENT_TYPE = {
    ADD_PAYMENT_INFO: 'ADD_PAYMENT_INFO',
    ADD_TO_CART: 'ADD_TO_CART',
    ADD_TO_WISHLIST: 'ADD_TO_WISHLIST',
    COMPLETE_REGISTRATION: 'COMPLETE_REGISTRATION',
    CONTACT: 'CONTACT',
    CUSTOMIZE_PRODUCT: 'CUSTOMIZE_PRODUCT',
    DONATE: 'DONATE',
    FIND_LOCATION: 'FIND_LOCATION',
    INITIATE_CHECKOUT: 'INITIATE_CHECKOUT',
    LEAD: 'LEAD',
    PAGE_VIEW: 'PAGE_VIEW',
    PURCHASE: 'PURCHASE',
    SCHEDULE: 'SCHEDULE',
    SEARCH: 'SEARCH',
    START_TRIAL: 'START_TRIAL',
    SUBMIT_APPLICATION: 'SUBMIT_APPLICATION',
    SUBSCRIBE: 'SUBSCRIBE',
    VIEW_CONTENT: 'VIEW_CONTENT',
  };

  const CUSTOM_EVENT_OPTION = [
    {
      value: CUSTOM_EVENT_TYPE.ADD_PAYMENT_INFO,
      label: 'Add Payment Info',
      desc: 'The addition of customer payment information during a checkout process.',
    },
    {
      value: CUSTOM_EVENT_TYPE.ADD_TO_CART,
      label: 'Add to Cart',
      desc: 'The addition of an item to a shopping cart or basket (example: checking an Add to Cart button on a website',
    },
    {
      value: CUSTOM_EVENT_TYPE.ADD_TO_WISHLIST,
      label: 'Wishlist',
      desc: 'The addition of items to a wishlist (example: clicking an Add to Wishlist button on a website',
    },
    {
      value: CUSTOM_EVENT_TYPE.COMPLETE_REGISTRATION,
      label: 'Complete Registration',
      desc: 'A submission of information by a customer in exchange for a service provided by your business (example: sign up for email subscription',
    },
    {
      value: CUSTOM_EVENT_TYPE.CONTACT,
      label: 'Contact',
      desc: 'A telephone/SMS, email, chat, or other type of contact between a customer and your business.',
    },
    {
      value: CUSTOM_EVENT_TYPE.CUSTOMIZE_PRODUCT,
      label: 'Customize Product',
      desc: 'The customization of products through a configuration tool or other application your business owns.',
    },
    {
      value: CUSTOM_EVENT_TYPE.DONATE,
      label: 'Donate',
      desc: 'The donation of funds to yours organization or cause.',
    },
    {
      value: CUSTOM_EVENT_TYPE.FIND_LOCATION,
      label: 'Find Location',
      desc: 'When a person finds one of your locations via web or app, with an intention to visit (example: searching for a product and finding it at one of your local stores',
    },
    {
      value: CUSTOM_EVENT_TYPE.INITIATE_CHECKOUT,
      label: 'Initiate Checkout',
      desc: 'The start of a checkout process.',
    },
    {
      value: CUSTOM_EVENT_TYPE.LEAD,
      label: 'Lead',
      desc: 'A submission of information by a customer with the understanding that they be contacted at a later date by your business',
    },
    {
      value: CUSTOM_EVENT_TYPE.PURCHASE,
      label: 'Purchase',
      desc: 'The completion of a purchase, usually signified by receiving order/purchase confirmation or a transaction receipt.',
    },
    {
      value: CUSTOM_EVENT_TYPE.SCHEDULE,
      label: 'Schedule',
      desc: 'The booking of an appointment to visit one of your locations.',
    },
    {
      value: CUSTOM_EVENT_TYPE.SEARCH,
      label: 'Search',
      desc: 'A search performed on your website (example: product searches, travel searches).',
    },
    {
      value: CUSTOM_EVENT_TYPE.START_TRIAL,
      label: 'Start Trial',
      desc: 'The start of a free trial of a product or service you offer (example: trial subscription)',
    },
    {
      value: CUSTOM_EVENT_TYPE.SUBMIT_APPLICATION,
      label: 'Submit Application',
      desc: 'The submission of an application for a product, service or program you offer (example: credit card, educational program or job).',
    },
    {
      value: CUSTOM_EVENT_TYPE.SUBSCRIBE,
      label: 'Subscribe',
      desc: 'The start of a paid subscription for a product or service you offer',
    },
    {
      value: CUSTOM_EVENT_TYPE.VIEW_CONTENT,
      label: 'View Content',
      desc: 'A visit to a content page you care about, such as a product page, landing page or article. Information about the page viewed can be passed to Facebook for use in dynamic ads.',
    },
  ];

  const MEDIA_CATEGORY = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
  };

  const MEDIA_CATEGORY_OPTION = [
    {
      key: 'image/jpeg',
      category: MEDIA_CATEGORY.IMAGE,
    },
    {
      key: 'image/gif',
      category: MEDIA_CATEGORY.IMAGE,
    },
    {
      key: 'image/png',
      category: MEDIA_CATEGORY.IMAGE,
    },
    {
      key: 'video/mp4',
      category: MEDIA_CATEGORY.VIDEO,
    },
  ];

  const URL_PARAMETER_TYPE = {
    AD_ID: '{{ad.id}}',
    ADSET_ID: '{{adset.id}}',
    CAMPAIGN_ID: '{{campaign.id}}',
    AD_NAME: '{{ad.name}}',
    ADSET_NAME: '{{adset.name}}',
    CAMPAIGN_NAME: '{{campaign.name}}',
    PLACEMENT: '{{placement}}',
    SITE_SOURCE_NAME: '{{site_source_name}}',
  };

  const URL_PARAMETER_LIST = [
    URL_PARAMETER_TYPE.AD_ID,
    URL_PARAMETER_TYPE.ADSET_ID,
    URL_PARAMETER_TYPE.CAMPAIGN_ID,
    URL_PARAMETER_TYPE.ADSET_NAME,
    URL_PARAMETER_TYPE.CAMPAIGN_NAME,
    URL_PARAMETER_TYPE.PLACEMENT,
    URL_PARAMETER_TYPE.SITE_SOURCE_NAME,
  ];

  const CTA_OBJECTIVE_LIST = [
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.BRAND_AWARENESS,
      options: [
        // 17 option
        'DOWNLOAD',
        'LEARN_MORE',
        'APPLY_NOW',
        'SHOP_NOW',
        'SUBSCRIBE',
        'CONTACT_US',
        'REQUEST_TIME',
        'LISTEN_NOW',
        'WHATSAPP_MESSAGE',
        'WATCH_MORE',
        'GET_SHOWTIMES',
        'SIGN_UP',
        'GET_QUOTE',
      ],
      // Try in Camera, See Menu, Book Now, Send Message
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.REACH,
      options: [
        // 22 options
        'DOWNLOAD',
        'LEARN_MORE',
        'APPLY_NOW',
        'SHOP_NOW',
        'SUBSCRIBE',
        'CONTACT_US',
        'GET_DIRECTIONS',
        'GET_SHOWTIMES',
        'CALL_NOW',
        'REQUEST_TIME',
        'WHATSAPP_MESSAGE',
        'LISTEN_NOW',
        'ORDER_NOW',
        'GET_QUOTE',
        'WATCH_MORE',
        'SIGN_UP',
      ],
      // Save, See Menu, Try in Camera, Book Now, Dial Code, Send Message
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
      options: [
        // 25 options
        'LEARN_MORE',
        'DOWNLOAD',
        'APPLY_NOW',
        'SUBSCRIBE',
        'WHATSAPP_MESSAGE',
        'WATCH_MORE',
        'LISTEN_NOW',
        'ORDER_NOW',
        'CALL_NOW',
        'SIGN_UP',
        'GET_OFFER',
        'SHOP_NOW',
        'CONTACT_US',
        'GET_SHOWTIMES',
        'REQUEST_TIME',
        'GET_QUOTE',
      ],
      // See Menu, Try On, Book Test Drive, Check Availability, Get Access, Get Tickets, Try in Camera, Send Message, Book Now
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
      options: [
        // 7 options
        'LEARN_MORE',
        'SHOP_NOW',
        'WHATSAPP_MESSAGE',
        'GET_QUOTE',
        'CALL_NOW',
      ],
      // Try in Camera, Send Message
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
      options: ['LIKE_PAGE'],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
      options: ['VIEW_EVENT'],
      // View event
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.MESSAGES,
      options: [
        // 17 options
        'SHOP_NOW',
        'LEARN_MORE',
        'APPLY_NOW',
        'SUBSCRIBE',
        'WATCH_MORE',
        'WHATSAPP_MESSAGE',
        'GET_SHOWTIMES',
        'ORDER_NOW',
        'SIGN_UP',
        'REQUEST_TIME',
        'CONTACT_US',
        'GET_QUOTE',
        'GET_OFFER',
      ],
      // See Menu, Preregister, Book Now, Send Message
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      options: [
        // 26 options
        'SHOP_NOW',
        'LEARN_MORE',
        'DOWNLOAD',
        'APPLY_NOW',
        'PLAY_GAME',
        'SUBSCRIBE',
        'SIGN_UP',
        'WATCH_MORE',
        'GET_SHOWTIMES',
        'GET_DIRECTIONS',
        'DONATE_NOW',
        'GET_OFFER',
        'GET_QUOTE',
        'CONTACT_US',
        'WHATSAPP_MESSAGE',
        'LISTEN_NOW',
        'REQUEST_TIME',
        'ORDER_NOW',
      ],
      // See Menu, Book Test Drive, Check Availability, Get Tickets, Try in Camera, Send message, Book Now, Get Directions
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.STORE_VISITS,
      options: [
        // 7 options
        'LEARN_MORE',
        'SHOP_NOW',
        'GET_OFFER',
        'GET_DIRECTIONS',
        'CALL_NOW',
        'ORDER_NOW',
      ],
      // Send message
    },
  ];

  const AD_LOCATION_TYPE = {
    AD_COUNTRY: 1,
    AD_COUNTRY_GROUP: 2,
    AD_REGION: 3,
    AD_CITY: 4,
    AD_ZIP: 5,
    AD_GEO_MARKET: 6,
  };

  const AD_LOCATION_STRING = {
    COUNTRY: 'country',
    REGION: 'region',
    CITY: 'city',
    SUB_CITY: 'subcity',
    NEIGHBORHOOD: 'neighborhood',
  };

  const AD_LOCATION_STRING_LIST = [
    {
      plural: 'countries',
      type: [AD_LOCATION_STRING.COUNTRY],
    },
    {
      plural: 'regions',
      type: [AD_LOCATION_STRING.REGION],
    },
    {
      plural: 'cities',
      type: [
        AD_LOCATION_STRING.CITY,
        AD_LOCATION_STRING.SUB_CITY,
        AD_LOCATION_STRING.NEIGHBORHOOD,
      ],
    },
  ];

  const TARGETING_CLASS = [
    'interests',
    'behaviors',
    'demographics',
    'life_events',
    'industries',
    'income',
    'family_statuses',
    'user_device',
    'user_os',
  ];

  const AD_LOCATION_PEOPLE_OPTION = [
    {
      label: 'People in living in or recently in this location',
      value: '1',
      desc: 'People whose home or most recent location is within the selcted area',
    },
    {
      label: 'People in living in this location',
      value: '2',
      desc: 'People whose home is within the selected area',
    },
    {
      label: 'People in recently in this location',
      value: '3',
      desc: 'People whose most recent location is within the selected area',
    },
    {
      label: 'People traveling in this location',
      value: '4',
      desc: 'People whose most recent location is within the selected area but whose home is more than 125mi/200km away',
    },
  ];

  const DEVICE_PLATFORM_TYPE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
    ALL: 'all',
  };

  const DEVICE_PLATFORM_OPTION = [
    {
      value: DEVICE_PLATFORM_TYPE.ALL,
      label: 'All Devices (Recommended)',
    },
    {
      value: DEVICE_PLATFORM_TYPE.MOBILE,
      label: 'Mobile',
    },
    {
      value: DEVICE_PLATFORM_TYPE.DESKTOP,
      label: 'Desktop',
    },
  ];

  const PUBLISHER_PLATFORM_TYPE = {
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    MESSENGER: 'messenger',
    AUDIENCE_NETWORK: 'audience_network',
  };

  const PUBLISHER_PLATFORM_OPTION = [
    {
      value: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
      label: 'Facebook',
    },
    {
      value: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
      label: 'Instagram',
    },
    {
      value: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
      label: 'Audience Network',
    },
    {
      value: PUBLISHER_PLATFORM_TYPE.MESSENGER,
      label: 'Messenger',
    },
  ];

  const PLACEMENT_POSITION_TYPE = [
    'facebook_positions',
    'instagram_positions',
    'audience_network_positions',
    'messenger_positions',
  ];

  const PLACEMENT_TYPE = {
    FEEDS: 'feed',
    STORIES_AND_REELS: 'stories_and_reels',
    IN_STREAM: 'in_stream',
    RIGHT_HAND_column: 'right_hand_column',
    INSTANT_ARTICLE: 'instant_article',
    MARKETPLACE: 'marketplace',
    VIDEO_FEEDS: 'video_feeds',
    STORY: 'story',
    SEARCH: 'search',
    INSTREAM_VIDEO: 'instream_video',
    STREAM: 'stream',
    SHOP: 'shop',
    EXPLORE: 'explore',
    REELS: 'reels',
    CLASSIC: 'classic',
    REWARDED_VIDEO: 'rewarded_video',
    MESSENGER_HOME: 'messenger_home',
    SPONSORED_MESSAGE: 'sponsored_message',
    IG_TV: 'igtv',
  };

  const PLACEMENT_GROUP = {
    FEEDS: 'feeds',
    STORIES_AND_REELS: 'stories_and_reels',
    IN_STREAM: 'in_stream',
    REELS_OVERLAY: 'reels_overlay',
    SEARCH: 'search',
    MESSAGES: 'messages',
    IN_ARTICLE: 'in_article',
    APPS_AND_SITES: 'app_and_sites',
  };

  const PLACEMENT_PLACEMENT_OPTION = [
    {
      value: PLACEMENT_GROUP.FEEDS,
      label: 'Feeds',
      desc: 'Get high visibility for your business with ads in feeds',
      data: {
        image: facebookNewsFeed,
        desc: 'We recommend square (1:1) images and vertical (4:5) videos.',
      },
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          label: 'Facebook News Feed',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookNewsFeed,
            desc: 'We recommend square (1:1) images and vertical (4:5) videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          label: 'Instagram Feed',
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          data: {
            image: instagramFeed,
            desc: 'We recommend square (1:1) images and vertical (4:5) videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          label: 'Facebook Marketplace',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookMarketPlace,
            desc: 'We recommend square (1:1) images and vertical (4:5) videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.VIDEO_FEEDS,
          label: 'Facebook Video Feeds',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookVideoFeeds,
            desc: 'We recommend square (1:1) images and vertical (4:5) videos.',
            extra: {
              text: 'Ads can appear in feeds of video-only content across Facebook, including Facebook Watch. Learn More',
              highlight: 'Learn More',
            },
          },
        },
        {
          value: PLACEMENT_TYPE.RIGHT_HAND_column,
          label: 'Facebook Right Column',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookRightColumn,
            desc: "This placement isn't available with the Brand awareness objective.",
          },
        },
        {
          value: PLACEMENT_TYPE.EXPLORE,
          label: 'Instagram Explore',
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          data: {
            image: instagramExplore,
            desc: 'We recommend square (1:1) images and vertical (4:5) videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.SHOP,
          label: 'Instagram Shop',
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          data: {
            image: instagramShop,
            desc: "This placement isn't available with the Brand awareness objective.",
          },
        },
        {
          value: PLACEMENT_TYPE.MESSENGER_HOME,
          label: 'Messenger Inbox',
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
          data: {
            image: messengerInbox,
            desc: "This placement isn't available with the Brand awareness objective.",
          },
        },
      ],
    },
    {
      value: PLACEMENT_GROUP.STORIES_AND_REELS,
      label: 'Stories and Reels',
      desc: 'Tell a rich, visual story with immersive, fullscreen vertical ads',
      data: {
        image: instagramStories,
        desc: 'For Stories: we recommend fullscreen vertical (9:16) images or videos',
        extra: {
          text: 'For Instagram Reels: use fullscreen vertical (9:16) videos of 30 seconds or less. We recommend including sound.',
        },
      },
      options: [
        {
          value: PLACEMENT_TYPE.STORY,
          label: 'Instagram Stories',
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          data: {
            image: instagramStories,
            desc: 'We recommend fullscreen vertical (9:16) images or videos.',
            extra: {
              text: "The style, formatting, image resolution and layout of your ad's media and text may be adjusted when it's likely to improve performance.",
            },
          },
        },
        {
          value: PLACEMENT_TYPE.STORY,
          label: 'Facebook Stories',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookStories,
            desc: 'We recommend fullscreen vertical (9:16) images or videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.STORY,
          label: 'Messenger Stories',
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
          data: {
            image: messengerStories,
            desc: 'We recommend fullscreen vertical (9:16) images or videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.REELS,
          label: 'Instagram Reels',
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          data: {
            image: instagramReels,
            desc: 'Use fullscreen vertical (9:16) videos of 30 seconds or less.',
          },
        },
      ],
    },

    {
      value: PLACEMENT_GROUP.IN_STREAM,
      label: 'In-Stream',
      desc: "Quickly capture people's attention while they're watching videos",
      data: {
        image: facebookInStreamVideos,
        desc: 'For Facebook In-Stream: we recommend fullscreen horizontal (16:9) or square (1:1) images or videos.',
        extra: {
          text: 'For Instagram In-Stream Videos: we recommend fullscreen vertical (9:16) videos of 15 seconds or less.',
        },
      },
      options: [
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          label: 'Facebook In-Stream Videos',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookInStreamVideos,
            desc: 'We recommend fullscreen horizontal (16:9) or square (1:1) images or videos.',
            extra: {
              text: 'In-stream is available for video and image ad formats.',
            },
          },
        },
        {
          value: PLACEMENT_TYPE.IG_TV,
          label: 'Instagram In-Stream Videos',
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          data: {
            image: instagramIGTV,
            desc: 'We recommend fullscreen vertical (9:16) videos. Videos are limited to 15 seconds or less.',
          },
        },
      ],
    },

    {
      value: PLACEMENT_GROUP.SEARCH,
      label: 'Search',
      desc: 'Get visibility for your business as people search on Facebook',
      data: {
        image: facebookSearchResults,
        desc: 'We recommend horizontal (1.91:1) images or square (1:1) videos.',
        extra: {
          text: 'This placement includes both general search and Marketplace search.',
        },
      },
      options: [
        {
          value: PLACEMENT_TYPE.SEARCH,
          label: 'Facebook Search Results',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookSearchResults,
            desc: 'We recommend horizontal (1.91:1) images or square (1:1) videos.',
            extra: {
              text: 'This placement includes both general search and Marketplace search.',
            },
          },
        },
      ],
    },

    {
      value: PLACEMENT_GROUP.MESSAGES,
      label: 'Messages',
      desc: 'Send offers or updates to people who are already connected to your business',
      data: {
        image: messengerSponsoredMessages,
        desc: 'We recommend horizontal (1.91:1) images.',
      },
      options: [
        {
          value: PLACEMENT_TYPE.SPONSORED_MESSAGE,
          label: 'Messenger Sponsored Messages',
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
          data: {
            image: messengerSponsoredMessages,
            desc: 'We recommend horizontal (1.91:1) images.',
          },
        },
      ],
    },

    {
      value: PLACEMENT_GROUP.IN_ARTICLE,
      label: 'In-Article',
      desc: 'Engage with people reading content from publishers',
      data: {
        image: facebookInstantArticle,
        desc: 'We recommend horizontal (1.91:1) images or videos.',
      },
      options: [
        {
          value: PLACEMENT_TYPE.INSTANT_ARTICLE,
          label: 'Facebook Instant Articles',
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
          data: {
            image: facebookInstantArticle,
            desc: 'We recommend horizontal (1.91:1) images or videos.',
          },
        },
      ],
    },

    {
      value: PLACEMENT_GROUP.APPS_AND_SITES,
      label: 'Apps and Sites',
      desc: 'Expand your reach with ads in external apps and websites',
      data: {
        image: audienceNetworkNativeBanner,
        desc: 'For Native, Banner, Interstitial and Rewarded Videos: we recommend fullscreen vertical (9:16) images or videos.',
        extra: {
          text: 'For In-Stream Videos: we recommend fullscreen horizontal (16:9) images or videos.',
        },
      },
      options: [
        {
          value: PLACEMENT_TYPE.CLASSIC,
          label: 'Audience Network Native, Banner and Interstitial',
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
          data: {
            image: audienceNetworkNativeBanner,
            desc: 'We recommend fullscreen vertical (9:16) images or videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.REWARDED_VIDEO,
          label: 'Audience Network Rewarded Videos',
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
          data: {
            image: audienceNetworkRewardedVideos,
            desc: 'We recommend fullscreen vertical (9:16) images or videos.',
          },
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          label: 'Audience Network In-Stream Videos',
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
          data: {
            image: audienceNetworkInStreamVideos,
            desc: 'We recommend fullscreen horizontal (16:9) images or videos.',
          },
        },
      ],
    },
  ];

  const UNAVAILABLE_PLACEMENT_DEVICES = [
    {
      device: DEVICE_PLATFORM_TYPE.ALL,
      unsupported: {
        platform: [],
        type: [],
      },
    },
    {
      device: DEVICE_PLATFORM_TYPE.DESKTOP,
      unsupported: {
        platform: [
          PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
          PUBLISHER_PLATFORM_TYPE.MESSENGER,
        ],
        type: [
          PLACEMENT_TYPE.STORY,
          PLACEMENT_TYPE.REELS,
          PLACEMENT_TYPE.SEARCH,
          PLACEMENT_TYPE.INSTANT_ARTICLE,
        ],
      },
    },
    {
      device: DEVICE_PLATFORM_TYPE.MOBILE,
      unsupported: {
        platform: [],
        type: [],
      },
    },
  ];

  const AD_FORMAT = {
    AUDIENCE_NETWORK_INSTREAM_VIDEO: 'AUDIENCE_NETWORK_INSTREAM_VIDEO',
    AUDIENCE_NETWORK_INSTREAM_VIDEO_MOBILE:
      'AUDIENCE_NETWORK_INSTREAM_VIDEO_MOBILE',
    AUDIENCE_NETWORK_OUTSTREAM_VIDEO: 'AUDIENCE_NETWORK_OUTSTREAM_VIDEO',
    AUDIENCE_NETWORK_REWARDED_VIDEO: 'AUDIENCE_NETWORK_REWARDED_VIDEO',
    BIZ_DISCO_FEED_MOBILE: 'BIZ_DISCO_FEED_MOBILE',
    DESKTOP_FEED_STANDARD: 'DESKTOP_FEED_STANDARD',
    FACEBOOK_REELS_BANNER: 'FACEBOOK_REELS_BANNER',
    FACEBOOK_REELS_MOBILE: 'FACEBOOK_REELS_MOBILE',
    FACEBOOK_REELS_STICKER: 'FACEBOOK_REELS_STICKER',
    FACEBOOK_STORY_MOBILE: 'FACEBOOK_STORY_MOBILE',
    FACEBOOK_STORY_STICKER_MOBILE: 'FACEBOOK_STORY_STICKER_MOBILE',
    INSTAGRAM_EXPLORE_CONTEXTUAL: 'INSTAGRAM_EXPLORE_CONTEXTUAL',
    INSTAGRAM_EXPLORE_IMMERSIVE: 'INSTAGRAM_EXPLORE_IMMERSIVE',
    INSTAGRAM_REELS: 'INSTAGRAM_REELS',
    INSTAGRAM_SHOP: 'INSTAGRAM_SHOP',
    INSTAGRAM_STANDARD: 'INSTAGRAM_STANDARD',
    INSTAGRAM_STORY: 'INSTAGRAM_STORY',
    INSTANT_ARTICLE_RECIRCULATION_AD: 'INSTANT_ARTICLE_RECIRCULATION_AD',
    INSTANT_ARTICLE_STANDARD: 'INSTANT_ARTICLE_STANDARD',
    INSTREAM_BANNER_DESKTOP: 'INSTREAM_BANNER_DESKTOP',
    INSTREAM_BANNER_MOBILE: 'INSTREAM_BANNER_MOBILE',
    INSTREAM_VIDEO_DESKTOP: 'INSTREAM_VIDEO_DESKTOP',
    INSTREAM_VIDEO_IMAGE: 'INSTREAM_VIDEO_IMAGE',
    INSTREAM_VIDEO_MOBILE: 'INSTREAM_VIDEO_MOBILE',
    JOB_BROWSER_DESKTOP: 'JOB_BROWSER_DESKTOP',
    JOB_BROWSER_MOBILE: 'JOB_BROWSER_MOBILE',
    MARKETPLACE_MOBILE: 'MARKETPLACE_MOBILE',
    MESSENGER_MOBILE_INBOX_MEDIA: 'MESSENGER_MOBILE_INBOX_MEDIA',
    MESSENGER_MOBILE_STORY_MEDIA: 'MESSENGER_MOBILE_STORY_MEDIA',
    MOBILE_BANNER: 'MOBILE_BANNER',
    MOBILE_FEED_BASIC: 'MOBILE_FEED_BASIC',
    MOBILE_FEED_STANDARD: 'MOBILE_FEED_STANDARD',
    MOBILE_FULLWIDTH: 'MOBILE_FULLWIDTH',
    MOBILE_INTERSTITIAL: 'MOBILE_INTERSTITIAL',
    MOBILE_MEDIUM_RECTANGLE: 'MOBILE_MEDIUM_RECTANGLE',
    MOBILE_NATIVE: 'MOBILE_NATIVE',
    RIGHT_COLUMN_STANDARD: 'RIGHT_COLUMN_STANDARD',
    SUGGESTED_VIDEO_DESKTOP: 'SUGGESTED_VIDEO_DESKTOP',
    SUGGESTED_VIDEO_MOBILE: 'SUGGESTED_VIDEO_MOBILE',
    WATCH_FEED_HOME: 'WATCH_FEED_HOME',
    WATCH_FEED_MOBILE: 'WATCH_FEED_MOBILE',
  };

  const AVAILABLE_PLACEMENT_OBJECTIVE = [
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.BRAND_AWARENESS,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTANT_ARTICLE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.SEARCH,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.VIDEO_FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.EXPLORE,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.REELS,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.IG_TV,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.REACH,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTANT_ARTICLE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.SEARCH,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.VIDEO_FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.EXPLORE,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.REELS,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.IG_TV,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.CLASSIC,
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.TRAFFIC,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.RIGHT_HAND_column,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTANT_ARTICLE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.SEARCH,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.VIDEO_FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.REELS,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.CLASSIC,
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
        },
        {
          value: PLACEMENT_TYPE.MESSENGER_HOME,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.POST_ENGAGEMENT,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTANT_ARTICLE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.SEARCH,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.VIDEO_FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.EXPLORE,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.PAGE_LIKES,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.EVENT_RESPONSES,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.MESSAGES,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.SEARCH,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.EXPLORE,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.SPONSORED_MESSAGE,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
        {
          value: PLACEMENT_TYPE.MESSENGER_HOME,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.CONVERSIONS,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.RIGHT_HAND_column,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTANT_ARTICLE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.INSTREAM_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.SEARCH,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.VIDEO_FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.EXPLORE,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.REELS,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.CLASSIC,
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
        },
        {
          value: PLACEMENT_TYPE.REWARDED_VIDEO,
          platform: PUBLISHER_PLATFORM_TYPE.AUDIENCE_NETWORK,
        },
        {
          value: PLACEMENT_TYPE.MESSENGER_HOME,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.MESSENGER,
        },
      ],
    },
    {
      objective: CAMPAIGN_OBJECTIVE_TYPE.STORE_VISITS,
      options: [
        {
          value: PLACEMENT_TYPE.FEEDS,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.MARKETPLACE,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.FACEBOOK,
        },
        {
          value: PLACEMENT_TYPE.STORY,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
        {
          value: PLACEMENT_TYPE.STREAM,
          platform: PUBLISHER_PLATFORM_TYPE.INSTAGRAM,
        },
      ],
    },
  ];

  const MEDIA_FORMAT_TYPE = {
    SINGLE: 'single',
    CAROUSEL: 'carousel',
  };

  const MEDIA_FORMAT_OPTION = [
    {
      value: MEDIA_FORMAT_TYPE.SINGLE,
      label: 'Single Image or Video',
      description: 'One image or video, or a slideshow with multiple images',
    },
    {
      value: MEDIA_FORMAT_TYPE.CAROUSEL,
      label: 'Carousel',
      description: '2 or more scrollable images or videos',
    },
  ];

  const AD_SETUP_TYPE = {
    CREATE_AD: 'create_ad',
    USE_EXISTING_POST: 'use_existing_post',
  };

  const AD_SETUP_OPTION = [
    {
      value: AD_SETUP_TYPE.CREATE_AD,
      label: 'Create Ad',
    },
    {
      value: AD_SETUP_TYPE.USE_EXISTING_POST,
      label: 'Use Existing Post',
    },
  ];

  const AD_POST_STATUS_TYPE = {
    ADDED_PHOTOS: 'added_photos',
    ADDED_VIDEO: 'added_video',
    APP_CREATED_STORY: 'app_created_story',
    APPROVED_FRIEND: 'approved_friend',
    CREATED_EVENT: 'created_event',
    CREATED_GROUP: 'created_group',
    CREATED_NOTE: 'created_note',
    MOBILE_STATUS_UPDATE: 'mobile_status_update',
    PUBLISHED_STORY: 'published_story',
    SHARED_STORY: 'shared_story',
    TAGGED_IN_PHOTO: 'tagged_in_photo',
    WALL_POST: 'wall_post',
  };

  const PLACEMENT_TYPE_OPTION = [
    {
      value: 'automatic_placement',
      label: 'Automatic Placements (Recommended)',
      description:
        "Use automatic placements to maximize your budget and help show your ads to more people. Facebook's delivery system will allocate your ad set's budget across multiple placements based on where they're likely to perform best.",
    },
    {
      value: 'manual_placement',
      label: 'Manual Placements',
      description:
        "Manually choose the places to show your ad. The more placements you select, the more opportunities you'll have to reach your target audience and achieve your business goals.",
    },
  ];

  return {
    // campaign
    CAMPAIGN_OBJECTIVE_TYPE,
    CAMPAIGN_OBJECTIVE_OPTION,
    BUYING_TYPE_OPTION,
    AD_CATEGORIES_TYPE,
    AD_CATEGORIES_LIST,
    BUDGET_TYPE,
    BUDGET_OPTION,
    BID_STRATEGY_TYPE,
    BID_STRATEGY_OPTION,
    AD_SCHEDULING_TYPE,
    AD_SCHEDULING_OPTION,
    BID_STRATEGY_OBJECTIVE,
    // ad set
    OPTIMIZATION_GOAL_TYPE,
    OPTIMIZATION_GOAL_OPTION,
    OPTIMIZATION_GOAL_DETAIL,
    BILLING_EVENT_TYPE,
    BILLING_EVENT_OPTION,
    GENDER_TYPE,
    GENDER_OPTION,
    DESTINATION_TYPE,
    DESTINATION_OPTION,
    CUSTOM_EVENT_TYPE,
    CUSTOM_EVENT_OPTION,
    AD_LOCATION_TYPE,
    AD_LOCATION_PEOPLE_OPTION,
    AD_LOCATION_STRING,
    PUBLISHER_PLATFORM_TYPE,
    PUBLISHER_PLATFORM_OPTION,
    PLACEMENT_PLACEMENT_OPTION,
    DEVICE_PLATFORM_TYPE,
    DEVICE_PLATFORM_OPTION,
    AVAILABLE_PLACEMENT_OBJECTIVE,
    UNAVAILABLE_PLACEMENT_DEVICES,
    AD_LOCATION_STRING_LIST,
    CONNECTION_LIST,
    CONNECTION_TYPE,
    ACTION_ATTRIBUTION_WINDOWS_OPTION,
    TARGETING_CLASS,
    PLACEMENT_POSITION_TYPE,
    PLACEMENT_TYPE_OPTION,
    // ad
    MEDIA_CATEGORY,
    MEDIA_CATEGORY_OPTION,
    URL_PARAMETER_TYPE,
    URL_PARAMETER_LIST,
    CTA_OBJECTIVE_LIST,
    MEDIA_FORMAT_TYPE,
    MEDIA_FORMAT_OPTION,
    AD_SETUP_TYPE,
    AD_SETUP_OPTION,
    AD_FORMAT,
    AD_POST_STATUS_TYPE,
  };
};
